import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_MASTER,
  headers: {
    "Content-Type": "application/json"
  }
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
    });

// import API from  "../API";


class sceheduleService {
    
    createPengajuan(jsondata) {
        return API.post("/jadwal/", jsondata);
    }
    

        getJadwal(page = 1, perPage = 5) {
            return API.get(`/jadwal?page=${page}&perPage=${perPage}`);
        }
        getInspeksi(page = 1, perPage = 5) {
            return API.get(`/jadwal/inspeksi?page=${page}&perPage=${perPage}`);
        }
        getSKP(page = 1, perPage = 5) {
            return API.get(`/jadwal/skp?page=${page}&perPage=${perPage}`);
        }
        getSurveillance(page = 1, perPage = 5) {
            return API.get(`/jadwal/surveillance?page=${page}&perPage=${perPage}`);
        }
        getUpi() {
            return API.get("/data/upi");
        }
        getPegawai() {
            return API.get("/data/pegawai");
        }
        getPegawaiInsp() {
            return API.get("/data/pegawai-insp");
        }
        getProduk() {
            return API.get("/data/produk");
        }
        getPropinsi() {
            return API.get("/data/propinsi");
        }
        getKota() {
            return API.get("/data/kota");
        }
        getIzin() {
            return API.get("/data/iz");
        }
        getStatus() {
            return API.get("/data/status");
        }

        prosesKatim(id) {
            return API.put(`/jadwal/katim/proses/${id}`);
        }

        approveKatim(id) {
            return API.put(`/jadwal/katim/approve/${id}`);
        }

        rejectKatim(id) {
            return API.put(`/jadwal/katim/reject/${id}`);
        }


        approveKepala(id) {
            return API.put(`/jadwal/kepala/approve/${id}`);
        }

        createSuratTugasBySespri(id, payload) {
            return API.post(`/jadwal/sespri/surat-tugas/${id}`, payload);
        }
        getJadwalByIdSurat(id) {
            return API.get(`/jadwal/surat-tugas/${id}`);
        }


}
export default new sceheduleService();
